// resources/js/woocommerce/account/account-addresses.js

let mounted = false;

export function mount() {
  if (mounted) return;
  mounted = true;

  // Alleen draaien als er account-panels zijn
  const hasPanels = document.querySelector('.wk-account-address__edit, .wk-account-details__edit');
  if (!hasPanels) return;

  // ---------- helpers ----------
  function openPanel(panel, btn) {
    panel.removeAttribute('hidden');
    if (btn) {
      btn.setAttribute('aria-expanded', 'true');
      if (!btn.hasAttribute('aria-controls') && panel.id) {
        btn.setAttribute('aria-controls', panel.id);
      }
    }
    try { panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (_) {}
    const first = panel.querySelector('input, select, textarea, button, [tabindex]:not([tabindex="-1"])');
    if (first && typeof first.focus === 'function') {
      try { first.focus({ preventScroll: true }); } catch (_) { first.focus(); }
    }
  }

  function closePanel(panel, btn) {
    panel.setAttribute('hidden', '');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function findAcfeWrappers(scope) {
    // Brede set selectors: ACFE/ACF varianten + jouw wk-form class
    const list = Array.from(scope.querySelectorAll(
      '.acfe-form, .acf-form, [data-acfe-form], [data-acf], .wk-form'
    ));
    // filter op aanwezigheid van ACF velden (veiligheid)
    return list.filter(el => el.querySelector('.acf-field'));
  }

  function hoistHiddenFormData(wrapperEl, formEl) {
    const blocks = [];

    // 1) standaard containers
    wrapperEl.querySelectorAll('.acf-form-data, .acfe-form-data, .acf-hidden')
      .forEach(n => blocks.push(n));

    // 2) soms als sibling naast wrapper
    [wrapperEl.previousElementSibling, wrapperEl.nextElementSibling]
      .filter(Boolean)
      .filter(el => el.matches('.acf-form-data, .acfe-form-data, .acf-hidden'))
      .forEach(n => blocks.push(n));

    // 3) losse hidden inputs
    wrapperEl.querySelectorAll(
      'input[type="hidden"][name^="acf["], input[type="hidden"][name^="acfe_"], input[type="hidden"][name="_acf"], input[type="hidden"][name*="acfe_form"]'
    ).forEach(n => blocks.push(n));

    Array.from(new Set(blocks)).forEach(node => {
      if (node && node.parentNode !== formEl) formEl.appendChild(node);
    });
  }

  // Voeg server-marker + veilige user-identiteit toe (client-side)
  function addMarker(formEl) {
    if (!formEl.querySelector('[name="wk_acfe_submit"]')) {
      const mk = document.createElement('input');
      mk.type = 'hidden'; mk.name = 'wk_acfe_submit'; mk.value = '1';
      formEl.appendChild(mk);
    }
  }
  function injectUserIdentity(formEl) {
    const root = document.querySelector('.wk-account');
    if (!root) return;
    const uid = root.getAttribute('data-user-id');
    const ulogin = root.getAttribute('data-user-login');

    if (uid && !formEl.querySelector('[name="ID"]')) {
      const id = document.createElement('input');
      id.type = 'hidden'; id.name = 'ID'; id.value = String(uid);
      formEl.appendChild(id);
    }
    if (ulogin && !formEl.querySelector('[name="user_login"]')) {
      const ul = document.createElement('input');
      ul.type = 'hidden'; ul.name = 'user_login'; ul.value = ulogin;
      formEl.appendChild(ul);
    }
  }

  // Maak tijdelijk <form> rond wrapper (alleen als we niet al ín een form zitten)
  function ensureForm(wrapperEl) {
    let form = wrapperEl.closest('form');
    let made = false;

    if (!form) {
      form = document.createElement('form');
      form.method = 'post';
      form.className = 'wk-temp-acfe-form';
      wrapperEl.parentNode.insertBefore(form, wrapperEl);
      form.appendChild(wrapperEl);
      made = true;
    }

    hoistHiddenFormData(wrapperEl, form);
    addMarker(form);
    injectUserIdentity(form);

    return { form, made };
  }

  function nativeSubmit(form) {
    const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitBtn) {
      submitBtn.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      return;
    }
    if (typeof form.requestSubmit === 'function') { form.requestSubmit(); return; }
    form.submit();
  }

  // ---------- toggles ----------
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-addr-toggle]');
    if (!btn) return;

    const sel = btn.getAttribute('data-addr-toggle');
    if (!sel) return;

    const panel = document.querySelector(sel);
    if (!panel) return;

    const isHidden = panel.hasAttribute('hidden');
    if (isHidden) openPanel(panel, btn);
    else closePanel(panel, btn);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    const openPanels = Array.from(document.querySelectorAll(
      '.wk-account-address__edit:not([hidden]), .wk-account-details__edit:not([hidden])'
    ));
    const last = openPanels.pop();
    if (!last) return;
    const btn = document.querySelector('[data-addr-toggle="#' + last.id + '"]') ||
                document.querySelector('[aria-controls="' + last.id + '"]');
    closePanel(last, btn);
  });

  // ---------- submit ----------
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-addr-submit]');
    if (!btn) return;

    const sel = btn.getAttribute('data-addr-submit');
    const panel = sel
      ? document.querySelector(sel)
      : btn.closest('.wk-account-address__edit, .wk-account-details__edit');

    if (!panel) return;

    // Niet in Woo checkout vormen rommelen
    if (panel.closest('form.woocommerce-checkout, .woocommerce-checkout')) {
      console.warn('[wk] Submit genegeerd binnen checkout context.');
      return;
    }

    const oldText = btn.textContent;
    btn.disabled = true;
    btn.dataset.loading = 'true';
    btn.textContent = (oldText || 'Opslaan') + '…';

    // 1) Als er al echte forms in het paneel staan -> dien die in
    const existingForms = Array.from(panel.querySelectorAll('form'));
    if (existingForms.length) {
      existingForms.forEach(f => { addMarker(f); injectUserIdentity(f); nativeSubmit(f); });
      setTimeout(() => {
        btn.disabled = false; btn.dataset.loading = 'false'; btn.textContent = oldText || 'Opslaan';
      }, 1500);
      return;
    }

    // 2) Geen forms? Dan ACFE-render als <div>. Wikkel wrappers tijdelijk in <form> en submit.
    const wrappers = findAcfeWrappers(panel);
    if (!wrappers.length) {
      console.warn('[wk] Geen ACFE/ACF wrapper met velden in paneel', panel);
      btn.disabled = false; btn.dataset.loading = 'false'; btn.textContent = oldText || 'Opslaan';
      return;
    }

    const madeForms = [];
    try {
      wrappers.forEach(w => {
        const { form, made } = ensureForm(w);
        if (made) madeForms.push(form);
        nativeSubmit(form);
      });
    } finally {
      // Als er geen pageload plaatsvindt (bv. AJAX), ruim tijdelijke forms na korte delay op
      setTimeout(() => {
        madeForms.forEach(f => {
          if (!f.isConnected) return;
          const child = f.firstElementChild; // onze wrapper
          if (child) f.parentNode.insertBefore(child, f);
          f.remove();
        });
        btn.disabled = false; btn.dataset.loading = 'false'; btn.textContent = oldText || 'Opslaan';
      }, 1800);
    }
  });

  // // Optioneel: paneel sluiten + refresh na AJAX-succes
  // document.addEventListener('acfe/form/submit_success', () => location.reload());
}
